module.exports = __webpack_public_path__ + "r-v3/img/control_chat.ebbc9eb6.svg";